import * as React from 'react';
import styled from 'styled-components';
import MuiPaper, { PaperProps as MuiPaperProps } from '@material-ui/core/Paper';

const StyledPaper = styled(MuiPaper)``;

export type DSPaperProps = Omit<MuiPaperProps, 'component'>;

export const DSPaper: React.FC<DSPaperProps> = props => <StyledPaper {...props} />;
DSPaper.displayName = 'DSPaper';
